@if (isViewOnly) {
    <div class="design-building-block-sign-up-overlay" style="height: 100% !important;"></div>
}

<div class="padding-24">
    @if (existingEvents) {
        <p class="typography-body-medium" i18n="@@CommonCategoryPickerTitle">Please select a category to continue</p>
    } @else {
        <p class="typography-body-medium" i18n="@@CommonSubjectPickerTitle">Please select a #subject# to continue</p>
    }
    <br>

    <lib-radio-card-group
        (cardClicked)="ItemSelected($event)">
        @for (item of (items | keyvalue: keepOrder) | slice: 0: visibleItemsCount; track item.key) {
            <lib-radio-card
                [value]="item.key">
                <ng-container title>
                    @if (item.key !== 'Other') {
                        {{item.key}}
                    } @else {
                        <ng-container i18n="@@CommonOtherTeachersLabel">Other</ng-container>
                    }
                </ng-container>
                <ng-container tagsTitle i18n="@@CommonTeachersColon">#Teachers#:</ng-container>
                <ng-container tags>
                    @if (item.value.length <= 3) {
                        @for (teacher of item.value; track teacher.ID) {
                            <lib-status-label
                                [kind]="StatusKind.Light"
                                [icon]="Icon.Common.PersonVoiceOver">
                                <ng-container label>
                                    {{teacher.Name}}
                                </ng-container>
                            </lib-status-label>
                        }
                    } @else if (item.value.length > 3) {
                        <lib-status-label
                            [kind]="StatusKind.Light"
                            [icon]="Icon.Common.PersonVoiceOver">
                            <ng-container label>
                                {{ item.value[0].Name }}
                            </ng-container>
                        </lib-status-label>
                        <lib-status-label
                            [kind]="StatusKind.Light"
                            [icon]="Icon.Common.PersonVoiceOver">
                            <ng-container label>
                                {{ item.value[1].Name }}
                            </ng-container>
                        </lib-status-label>
                        <lib-status-label
                            [kind]="StatusKind.Neutral"
                            [icon]="Icon.Common.Groups"
                            toolTipPosition="below"
                            [toolTipText]="item.value | method: GetMoreTeacherTooltipText">
                            <ng-container label>
                                +{{(item.value.length - 2)}} more
                            </ng-container>
                        </lib-status-label>
                    }
                </ng-container>
            </lib-radio-card>
        }
        </lib-radio-card-group>
        @if (visibleItemsCount <  totalItemsLength) {
            <div class="d-flex justify-content-center margin-top-16">
                <lib-button
                    [prefixIcon]="Icon.Common.ExpandMore"
                    [kind]="ButtonKind.Link"
                    (clicked)="ShowMoreItems()">
                    <ng-container label i18n="@@CommonShowMoreButton">Show More</ng-container>
                </lib-button>
            </div>
        }

</div>
<!-- <mat-divider></mat-divider>
<lib-submission-bar
    [kind]="SubmissionBarKind.WidgetBasic">
    <lib-button
        [loading]="clicked"
        [isViewOnly]="isViewOnly"
        [disabled]="itemSelected === null"
        (clicked)="Signup()">
        <ng-container label i18n="@@CommonContinueButton">Continue</ng-container>
    </lib-button>
</lib-submission-bar> -->
